<template>
	<BaseSelect
		:id="id"
		:value="value"
		:selected="selected"
		:options="options"
		v-on="$listeners"
		v-slot="{
			pSelectedOption,
			pOptions,
			pExpanded,
			pInitial,
			mOpen,
			mClose,
			mToggle,
			mSelect,
			mSelectFirst,
			mSelectLast,
			mSelectDown,
			mSelectUp
		}"
	>
		<div v-bind="$attrs" class="tab-view-select">
			<span :id="labelId" class="visually-hidden">{{ label }}</span>
			<BaseSelectButton
				:id="buttonId"
				ref="baseSelectButton"
				class="tab-view-select-button"
				:expanded="pExpanded"
				:labelledBy="ariaLabelledBy"
				:initial="pInitial"
				:toggle="mToggle"
				:open="mOpen"
				:selectDown="mSelectDown"
				:selectUp="mSelectUp"
			>
				<span class="inner">
					{{ pSelectedOption.label }}
					<span
						:class="['icon', pExpanded ? 'icon-bold-up' : 'icon-bold-down']"
						aria-hidden="true"
					/>
				</span>
			</BaseSelectButton>
			<BaseSelectList
				class="tab-view-select-list"
				:expanded="pExpanded"
				:labelledBy="labelId"
				:close="mClose"
				:selectFirst="mSelectFirst"
				:selectLast="mSelectLast"
				:selectDown="mSelectDown"
				:selectUp="mSelectUp"
				:selectedOption="pSelectedOption"
			>
				<BaseSelectOption
					v-for="(option, index) in pOptions"
					class="tab-view-select-option"
					:class="{ disabled: option.disabled }"
					:key="option.id"
					:id="option.id"
					:index="index"
					:selected="option.selected"
					:select="mSelect"
					:aria-disabled="option.disabled ? 'true' : null"
				>
					{{ option.label }}
				</BaseSelectOption>
			</BaseSelectList>
		</div>
	</BaseSelect>
</template>

<script>
import { Select } from "../../select/mixins";
import BaseSelect from "../../select/base/BaseSelect";
import BaseSelectButton from "../../select/base/SelectButton";
import BaseSelectList from "../../select/base/SelectList";
import BaseSelectOption from "../../select/base/SelectOption";

export default {
	name: "TabViewSelect",

	mixins: [Select],

	components: {
		BaseSelect,
		BaseSelectButton,
		BaseSelectList,
		BaseSelectOption
	},

	methods: {
		focusBaseSelectButton() {
			this.$refs.baseSelectButton.toggleFocus(true);
		}
	}
};
</script>

<style lang="scss" scoped>
.tab-view-select {
	position: relative;
	margin: 20px 0 32px;

	.icon {
		color: $color--red;
		font-size: 14px;
	}
}

.tab-view-select-button {
	width: 100%;
	position: relative;
	padding: 16px 20px 16px 20px;
	background-color: $color--white;
	font-family: "Univers LT Std", Arial, sans-serif;
	font-weight: $font-weight--bold;
	font-size: 15px;
	letter-spacing: em(-0.15, 15);
	line-height: 15px;
	color: $color--almost-black;
	border: 1px solid $color--lighter-gray;
	cursor: pointer;
	z-index: 4;

	&::before {
		content: "";
		border-left: 6px solid $color--red;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}

	.inner {
		display: flex;
		justify-content: space-between;
	}
}

.tab-view-select-list {
	display: none;
	width: 100%;
	position: absolute;
	overflow: hidden;
	list-style-type: none;
	margin: 0;
	background-color: $color--white;
	box-shadow: 0 8px 10px 1px rgba(255, 212, 212, 0.14),
		0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);

	&.active {
		display: block;

		@include to-md {
			border: 1px solid $color--lighter-gray;
			border-bottom: 0;
			z-index: 3;
			overflow: visible;
		}
	}

	.tab-link {
		@include to-md {
			border-bottom: 1px solid $color--lighter-gray;
			display: block;
			position: relative;
		}
	}
}

.tab-view-select-option {
	margin: 0;
	padding: 16px 16px 16px 20px;
	font-size: 15px;
	letter-spacing: em(-0.15, 15);
	line-height: 15px;
	border-bottom: 1px solid $color--lighter-gray;
	cursor: pointer;

	&:hover {
		text-decoration: underline;
		background-color: $color--neutral-8;
	}

	&.disabled {
		color: $color--light-gray;
		pointer-events: none;
	}
}
</style>
